<div
  *ngIf="show"
  class="alert alert-warning mb-0"
  role="alert"
  data-testid="buyer-email-verification-banner"
>
  <ng-container *ngIf="emailStatus === 'bad'; else unverified">
    We couldn't deliver to your email address. Contact customer service via chat
    or email to fix it.
  </ng-container>
  <ng-template #unverified>
    Your email address hasn't been verified.<ng-container *ngIf="gateOn">
    You can't place orders until it is.</ng-container>
    <a
      href="javascript:void(0)"
      class="alert-link ml-2"
      [class.disabled]="pending"
      (click)="!pending && resend()"
      data-testid="buyer-email-verification-send"
      >Verify Email</a
    >
  </ng-template>
</div>
